import { useState } from "react";
import { LuSettings2 } from "react-icons/lu";

import OutsideAlerter from "components/outsideAlerter/OutsideAlerter";
import MobileProductsFilter from "./MobileProductsFilter";

import "./MobileNav.scss";

const MobileNav = ({
  slug,
  minPrice,
  maxPrice,
  filtersData,
  handleFilterToggle,
  handlePriceChange,
  searchParams,
}: any) => {
  const [openFilter, setOpenFilter] = useState(false);
  const showFilter = () => {
    let backdrop = document.getElementsByClassName(
      "Backdrop"
    )[0] as unknown as HTMLElement;
    let filterMenu = document.getElementById(
      "Filter-Nav"
    ) as unknown as HTMLElement;
    if (backdrop) {
      backdrop.style.backgroundColor = "#979292";
      backdrop.style.zIndex = "700";
      backdrop.style.display = "block";
    }
    if (filterMenu) {
      filterMenu.style.display = "block";
      setOpenFilter(true);
    }
  };
  const closeFilter = () => {
    let backdrop = document.getElementsByClassName(
      "Backdrop"
    )[0] as unknown as HTMLElement;
    let filterMenu = document.getElementById(
      "Filter-Nav"
    ) as unknown as HTMLElement;
    if (backdrop) {
      backdrop.style.backgroundColor = "transparent";
      backdrop.style.zIndex = "0";
      backdrop.style.display = "none";
    }
    if (filterMenu) {
      filterMenu.style.zIndex = "0";
      filterMenu.style.display = "none";
      setOpenFilter(false);
    }
  };
  return (
    <>
      <button className="Filter-Mobile-Button" onClick={showFilter}>
        <label>Filtriraj</label>
        <LuSettings2 />
      </button>

      {openFilter === true ? (
        <OutsideAlerter close={closeFilter}>
          <MobileProductsFilter
            slug={slug}
            minPrice={minPrice}
            maxPrice={maxPrice}
            filtersData={filtersData}
            handleFilterToggle={handleFilterToggle}
            handlePriceChange={handlePriceChange}
            searchParams={searchParams}
            openBurger={openFilter}
            closeBurger={closeFilter}
          />
        </OutsideAlerter>
      ) : (
        // <OutsideAlerter close={closeFilter}>
        <MobileProductsFilter
          slug={slug}
          minPrice={minPrice}
          maxPrice={maxPrice}
          filtersData={filtersData}
          handleFilterToggle={handleFilterToggle}
          handlePriceChange={handlePriceChange}
          searchParams={searchParams}
          openBurger={openFilter}
          closeBurger={closeFilter}
        />
        // </OutsideAlerter>
      )}
    </>
  );
};
export default MobileNav;
